export const access_key = "e98ee4d7e8e6b0bfafe9cb6af132fee12f90432b";
export const baseUrl = process.env.REACT_APP_API_URL;
export const YM_ID = process.env.REACT_APP_YM_ID;

export const errors = {
  "Incorrent date_arrival":
    "По какой-то причине отклик на вакансию не обработан. Пожалуйста, попробуйте заново",
  "Vacancy candidate is exists":
    "Этим кандидатом уже откликались на данную вакансию"
};

export const contract_types = {
  gpx: "ГПХ",
  self: "Самозанятые",
  ip: "ИП"
};
